// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HYCWC3Rf4XZ_rNY14H1w {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  margin-bottom: 16px;
  margin-top: 30px;
  max-width: 1440px;
}

.Zg1jRjlHgr_oPLEOfV6V {
  max-width: 325px;
  text-align: justify;
  white-space: pre-line;
  font-size: 18px;
}

.akwzAryW56Ou6_alwSik  {
  width: 40%;
  max-width: 720px;
}

.Ur9gx8yPGfJGOR4IRKL9 {
  display: flex;
  flex-direction: row;
}

.YOHCHoGIKC_5VeUJpJKw {
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  background-color: rgb(12, 35, 166);
  border-radius: 100%;
  color: rgb(255, 253, 250);
  transition: .3s;
}

.Q7wWWleLhmXhFWAR_oNc {
  width: 25px;
  height: 25px;
  color: white;
  fill: white;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .HYCWC3Rf4XZ_rNY14H1w {
    width: 100%;
    flex-direction: column;
  }

  .akwzAryW56Ou6_alwSik {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Footer/Footer.module.css"],"names":[],"mappings":"AAGA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l from breakpoints;\n\n.footerContainer {\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: auto;\n  margin-bottom: 16px;\n  margin-top: 30px;\n  max-width: 1440px;\n}\n\n.footer {\n  max-width: 325px;\n  text-align: justify;\n  white-space: pre-line;\n  font-size: 18px;\n}\n\n.footerText  {\n  width: 40%;\n  max-width: 720px;\n}\n\n.footerSocial {\n  display: flex;\n  flex-direction: row;\n}\n\n.footerSocialIcon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 16px;\n  background-color: rgb(12, 35, 166);\n  border-radius: 100%;\n  color: rgb(255, 253, 250);\n  transition: .3s;\n}\n\n.icon {\n  width: 25px;\n  height: 25px;\n  color: white;\n  fill: white;\n}\n\n@media screen and (max-width: tablet-l) {\n  .footerContainer {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .footerText {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"footerContainer": `HYCWC3Rf4XZ_rNY14H1w`,
	"footer": `Zg1jRjlHgr_oPLEOfV6V`,
	"footerText": `akwzAryW56Ou6_alwSik`,
	"footerSocial": `Ur9gx8yPGfJGOR4IRKL9`,
	"footerSocialIcon": `YOHCHoGIKC_5VeUJpJKw`,
	"icon": `Q7wWWleLhmXhFWAR_oNc`
};
export default ___CSS_LOADER_EXPORT___;
